export class Client {
  key: number;
  name: string;
  sortName: string;
  id: string;
  location: string;
  type: string;
  isBIN: boolean;
}
